/* ==========================================================
   Aaliyan's Engage — runtime
   - Free-delivery bar animation inside the cart drawer
   - Cart count bump on add
   - Touch "peek" at second product photo
   - Social-proof toast rotation (real orders only, set in theme editor)
   - Scroll reveals
   ========================================================== */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------- Free-delivery bar ---------- */
  function initFreeDelivery() {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    var lastPct = null;
    var wasUnlocked = false;

    function current() {
      var fill = drawer.querySelector("[data-ae-fd-fill]");
      if (!fill) return null;
      return { fill: fill, box: drawer.querySelector("[data-ae-fd]"), pct: parseFloat(fill.dataset.pct) || 0 };
    }

    function animate(from) {
      var c = current();
      if (!c) return;
      if (reduceMotion) {
        c.fill.style.width = c.pct + "%";
      } else {
        c.fill.style.transition = "none";
        c.fill.style.width = from + "%";
        void c.fill.offsetWidth; // force reflow so the transition runs
        c.fill.style.transition = "";
        c.fill.style.width = c.pct + "%";
      }
      var unlocked = c.pct >= 100;
      if (unlocked && !wasUnlocked && c.box && !reduceMotion) {
        c.box.classList.add("is-pop");
        setTimeout(function () { c.box && c.box.classList.remove("is-pop"); }, 700);
      }
      wasUnlocked = unlocked;
      lastPct = c.pct;
    }

    var init = current();
    if (init) { lastPct = init.pct; wasUnlocked = init.pct >= 100; }

    // Body re-rendered after cart changes
    var body = drawer.querySelector("[data-cart-drawer-body]");
    if (body) {
      new MutationObserver(function () {
        var c = current();
        if (!c) return;
        if (drawer.hidden) {
          lastPct = c.pct;
          wasUnlocked = c.pct >= 100;
          c.fill.style.width = c.pct + "%";
        } else {
          animate(lastPct == null ? 0 : lastPct);
        }
      }).observe(body, { childList: true });
    }

    // Drawer opened → fill from zero for a satisfying sweep
    new MutationObserver(function () {
      if (!drawer.hidden) animate(0);
    }).observe(drawer, { attributes: true, attributeFilter: ["hidden"] });
  }

  /* ---------- Cart count bump ---------- */
  function initCartBump() {
    document.addEventListener("cart:updated", function () {
      setTimeout(function () {
        var el =
          document.querySelector("#cart-icon-bubble") ||
          (document.getElementById("cartCount") && document.getElementById("cartCount").closest("a"));
        if (!el || reduceMotion) return;
        el.classList.remove("ae-bump");
        void el.offsetWidth;
        el.classList.add("ae-bump");
      }, 350);
    });
  }

  /* ---------- Touch peek at 2nd image ---------- */
  function initPeek() {
    if (reduceMotion || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    var peeked = 0;
    var MAX = 6; // keep it subtle: only the first few cards a shopper sees
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
        var card = entry.target;
        io.unobserve(card);
        if (peeked >= MAX) return;
        peeked++;
        setTimeout(function () {
          card.classList.add("ae-peek");
          setTimeout(function () { card.classList.remove("ae-peek"); }, 1400);
        }, 900 + (peeked % 3) * 250);
      });
    }, { threshold: [0.6] });
    document.querySelectorAll(".p-card").forEach(function (card) {
      if (card.querySelector(".p-card__link img.alt")) io.observe(card);
    });
  }

  /* ---------- Social-proof toast ---------- */
  function initSocialProof() {
    var root = document.querySelector("[data-ae-sp]");
    if (!root) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-ae-sp-item]"));
    if (!cards.length) return;

    var firstDelay = (parseInt(root.dataset.firstDelay, 10) || 8) * 1000;
    var interval = (parseInt(root.dataset.interval, 10) || 15) * 1000;
    var duration = (parseInt(root.dataset.duration, 10) || 5) * 1000;
    var maxShows = parseInt(root.dataset.max, 10) || 4;
    var KEY = "ae_sp_state";

    function load() {
      try { return JSON.parse(sessionStorage.getItem(KEY)) || { shown: 0, idx: 0, off: false }; }
      catch (e) { return { shown: 0, idx: 0, off: false }; }
    }
    function save(s) {
      try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* storage blocked */ }
    }

    var state = designMode ? { shown: 0, idx: 0, off: false } : load();
    if (state.off) return;
    var timer;

    function hideAll() {
      cards.forEach(function (c) {
        c.classList.remove("is-in");
        setTimeout(function () { if (!c.classList.contains("is-in")) c.hidden = true; }, 450);
      });
    }

    function showNext() {
      if (!designMode && state.shown >= maxShows) return;
      var card = cards[state.idx % cards.length];
      card.hidden = false;
      void card.offsetWidth;
      card.classList.add("is-in");
      state.idx = (state.idx + 1) % cards.length;
      state.shown++;
      save(state);
      timer = setTimeout(function () {
        hideAll();
        timer = setTimeout(showNext, interval);
      }, duration);
    }

    root.addEventListener("click", function (e) {
      if (!e.target.closest("[data-ae-sp-close]")) return;
      e.preventDefault();
      clearTimeout(timer);
      hideAll();
      state.off = true;
      save(state);
    });

    // Don't compete with an open cart drawer
    document.addEventListener("cart:updated", hideAll);

    timer = setTimeout(showNext, designMode ? 1200 : firstDelay);
  }

  /* ---------- Scroll reveals ---------- */
  function initReveals() {
    if (reduceMotion || designMode || !("IntersectionObserver" in window)) return;
    var vh = window.innerHeight;
    var targets = [];

    // Product cards — staggered
    var groups = new Map();
    document.querySelectorAll("#MainContent .p-card").forEach(function (card) {
      var parent = card.parentElement;
      var n = groups.get(parent) || 0;
      groups.set(parent, n + 1);
      card.style.setProperty("--ae-delay", (n % 4) * 80 + "ms");
      targets.push(card);
    });

    // Non-product sections (banners, trust strip, text) — skip the first (hero)
    var sections = document.querySelectorAll("#MainContent > .shopify-section");
    Array.prototype.forEach.call(sections, function (sec, i) {
      if (i === 0) return;
      if (sec.querySelector(".p-card")) {
        // reveal just the heading row of product carousels
        var head = sec.querySelector("h2");
        if (head) targets.push(head.parentElement || head);
        return;
      }
      targets.push(sec);
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });

    targets.forEach(function (el) {
      // Leave anything already on screen alone — no flash, no LCP hit
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) return;
      el.classList.add("ae-reveal");
      io.observe(el);
    });
  }

  ready(function () {
    initFreeDelivery();
    initCartBump();
    initPeek();
    initSocialProof();
    initReveals();
  });
})();
